import { useMemo } from 'react';
import { getErrorMessage, mapFirebaseError } from '@/lib/error-handling';

interface AuthErrorInfo {
  message: string;
  isEmailError: boolean;
  isPasswordError: boolean;
  isGeneralError: boolean;
}

interface FirebaseError {
  code?: string;
  message?: string;
}

export function useAuthError(error: FirebaseError | null | undefined, type: 'login' | 'signup' = 'login'): AuthErrorInfo | null {
  return useMemo(() => {
    if (!error) return null;
    
    // Map Firebase error to AuthError for proper handling
    const authError = mapFirebaseError(error);
    const message = getErrorMessage(authError);
    
    const emailErrorCodes = type === 'login' 
      ? ['auth/invalid-email', 'auth/user-not-found']
      : ['auth/invalid-email', 'auth/email-already-in-use'];
      
    const passwordErrorCodes = type === 'login'
      ? ['auth/wrong-password', 'auth/invalid-credential']
      : ['auth/weak-password'];
    
    const isEmailError = emailErrorCodes.includes(error.code || '');
    const isPasswordError = passwordErrorCodes.includes(error.code || '');
    
    return {
      message,
      isEmailError,
      isPasswordError,
      isGeneralError: !isEmailError && !isPasswordError
    };
  }, [error, type]);
} 
